import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Performance from './components/performance';
// import Targets from './components/targets';
import YearFilter from './components/year-filter';
import LoadingState from '../common/loading-state';
import config from '../../../src/globs/config';
import gaPush from '../../globs/utils/google-analytics';

const TABS = {
  FIRST: 'till date',
  SECOND: 'targets',
};

class MyPerformance extends Component {

  state = {
    activeTab: TABS.FIRST,
    filterOpen: false,
    year: new Date().getFullYear(),
    currentYear: new Date().getFullYear(),
    orderData: {},
    isLoading: true,
    selectedMonth: moment().month() + 1,
    selectedYear: moment().year(),
  }

  componentDidMount() {
    const { props } = this;
    this.fireGaEventPagePath(window.location.pathname +
      window.location.search);
    // console.log('in my perf componentDidMount', this.props.match.params.customerId);
    // get data for graph
    const custId = this.props.match.params.customerId;
    const salesOfficerId = props.user.id;
    this.getGraphData();
    const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${custId}/performance_years`;
      props.dataLoad({
        key: 'performanceYears',
        url,
      });
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    const { props } = this;
    // Only update when API status changes and data actually changed
    // Prevent infinite loops in React 19
    if (prevProps.ajaxStatuses.fetchGraphData === 'PENDING' &&
      props.ajaxStatuses.fetchGraphData === '') {
      console.log('props inside ===>', props.myPerformance, prevProps.myPerformance);
      // Only update if data actually changed
      if (this.state.orderData !== props.myPerformance || this.state.isLoading !== false) {
        this.setState({
          orderData: props.myPerformance,
          isLoading: false,
        });
      }
    }
    if (prevProps.ajaxStatuses.fetchMyPerformance === 'PENDING' &&
      props.ajaxStatuses.fetchMyPerformance === '') {
      console.log('props inside ===>', props.myPerformance, prevProps.myPerformance);
      // Only update if data actually changed
      if (this.state.orderData !== props.myPerformance || this.state.isLoading !== false) {
        this.setState({
          orderData: props.myPerformance,
          isLoading: false,
        });
      }
    }
  }

  getGraphData = () => {
    const { props, state } = this;
    // get data for graph

    const salesOfficerId = props.user.id;
    const custId = this.props.match.params.customerId
    const graphData = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${custId}/graph_data?year=${state.year}`;
    props.dataLoad({
      key: 'fetchGraphData',
      url: graphData,
    });
  }

  setYear = (year) => {
    console.log('year ====>', year);
    this.fireGaEvent('TonageReport', 'YearFilterClicked', year);
    this.setState({
      year,
      filterOpen: false,
      isLoading: true,
      orderData: {},
    }, () => this.getGraphData());
  }

  fetMyPerformanceData = () => {
    const { props, state } = this;
    console.log('props ====>', props);
    // dont delete the below commented line
    // if (state.orderData[`${state.selectedYear}-${state.selectedMonth}`] && state.orderData[`${state.selectedYear}-${state.selectedMonth}`].total_quantity > 0) {
      const dateFrom = moment(new Date(`${state.selectedYear}-${state.selectedMonth}-01`)).format('YYYY-MM-DD');
      const lastDayOfMonth = new Date(state.selectedYear, state.selectedMonth, 0).getDate();
      const dateTo = moment(new Date(`${state.selectedYear}-${state.selectedMonth}-${lastDayOfMonth}`)).format('YYYY-MM-DD');
      const salesOfficerId = props.user.id;
      const custId = this.props.match.params.customerId
      const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${custId}/my_performances?date_from=${dateFrom}&date_to=${dateTo}`;
      this.setState({
        isLoading: false,
      });
      props.dataLoad({
        key: 'fetchMyPerformance',
        url
      });
    // }
  }

  tabChange = (tab) => {
    const { state: { activeTab } } = this;
    if (tab !== activeTab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  fetchFilterData = (date) => {
    const month = date.split('-')[1];
    const year = date.split('-')[0];
    this.setState({
      selectedYear: year,
      selectedMonth: month,
    }, () => {
      this.fetMyPerformanceData();
    });
  }

  closeFilter = () => {
    this.setState({
      filterOpen: false,
    });
  }

  renderFilterButton = () => (
    <button
      type="button"
      className={`icon-filter ${this.state.currentYear !== this.state.year ? 'filter-active' : ''}`}
      onClick={() => this.setState({
        filterOpen: true,
      })}
    />
  )

  fireGaEventPagePath = (path) => {
    gaPush('pageview', {
      path,
    });
  };

  fireGaEvent = (act, action, labelIn) => {
    const label = `${labelIn}`;
    gaPush('event', {
      category: act,
      action,
      label,
    });
  };
  

  render() {
    const { props, state: { activeTab, filterOpen, year, currentYear } } = this;
    let allYears = props.performanceYears || [];
    if (allYears.indexOf(currentYear) === -1) allYears = [currentYear].concat(allYears);
    const opts = allYears.map(_year => ({ value: _year, text: _year }));
    console.log('state for my per===>', this.state);
    return (
      <div className="lr-main">
        { this.state.isLoading &&
        <div>
          <LoadingState />
          <div className="loadingContainer" />
        </div>
        }
        <div className="loadingContainer" />
        <div className="lr-performance lr-main-view">
          {/* <Header
            onClick={() => props.push('/home')}
            menu={props.intl.formatMessage({ id: 'Dashboard.myPerformanceLabel' })}
            rightMenu={this.renderFilterButton()}
          /> */}
          <div className="lr-main-view__header">
            <button
              type="button"
              onClick={() => this.props.history.goBack()}
              className="lr-main-view__header-title versementheader"
            >
              <i className="icon-back" />
              <span>Tonnage Report</span>
            </button>
            {
              this.renderFilterButton()
            }
          </div>
          <div className="lr-main-view__body">
            {/* <Navigation>
              <NavigationTab
                label={props.intl.formatMessage({
                  id: 'Targets.tab.tilldate',
                })}
                active={activeTab === TABS.FIRST}
                onClick={() => this.tabChange(TABS.FIRST)}
              />
              {/* <NavigationTab
                label={props.intl.formatMessage({
                  id: 'Targets.tab.targets',
                })}
                active={activeTab === TABS.SECOND}
                onClick={() => this.tabChange(TABS.SECOND)}
              />
            </Navigation> */}
            {
              activeTab === TABS.FIRST && Object.keys(this.state.orderData).length !== 0 &&
              <Performance
                ordersxes={this.state.orderData}
                year={year}
                currentYear={currentYear}
                user={props.user}
                fetchFilterData={this.fetchFilterData}
              />
            }
            {/* {
              activeTab === TABS.SECOND &&
              <Targets {...props} />
            } */}
          </div>
          {
            filterOpen &&
            <YearFilter
              onSelect={this.setYear}
              selectedOptVal={year}
              options={opts}
              onClose={this.closeFilter}
            />
          }
        </div>
      </div>
    );
  }
}

MyPerformance.propTypes = {
  ajaxDataLoadStatuses: PropTypes.shape({
    fetchGraphData: PropTypes.string,
    fetchMyPerformance: PropTypes.string,
  }),
  myPerformance: PropTypes.shape({
  }),
};

MyPerformance.defaultProps = {
  ajaxDataLoadStatuses: undefined,
  myPerformance: undefined,
};

export default MyPerformance;
